import { useEffect, useState } from "react";
import {
  TextField,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  FormHelperText,
  Checkbox,
  ListItemText,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import translations from "../../translations/updateUserFormTranslation";
import ClearIcon from "@mui/icons-material/Clear";
// import { Contexts } from "../contexts";
import { useAllBranches } from "../../contexts/BranchesContext";
import { isTestEnv } from "../../globals";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";


const UpdateUserForm = ({ rolesList, user, onUpdateUser, onCancel, isAdmin }) => {

  const [hospitals, setHospitals] = useState([]);
  const [loadingHospitals, setLoadingHospitals] = useState(false);

  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  //user.Role = id array
  //updatedUser.Role = json include id and names

  const [updatedUser, setUpdatedUser] = useState(user);
  // const [context, dispatch] = useContext(Contexts);
  const { allBranches } = useAllBranches();
  isTestEnv && console.log("rolesList", rolesList);

  // בדיקה האם למשתמש יש הרשאת ChemoRecordsPage
  const hasChemoRecordsPermission = () => {
    if (!updatedUser.Role || !rolesList.length) return false;

    const userRoleIds = Array.isArray(updatedUser.Role)
      ? updatedUser.Role
      : Object.keys(updatedUser.Role);

    return userRoleIds.some(roleId => {
      const role = rolesList.find(r => r._id === roleId);
      return role && role.ChemoRecordsPage === true;
    });
  };

  // שליפת רשימת בתי חולים מהבקאנד כשיש הרשאת ChemoRecords
  useEffect(() => {
    const fetchHospitals = async () => {
      if (hasChemoRecordsPermission() && hospitals.length === 0) {
        setLoadingHospitals(true);
        try {
          const response = await execute(
            "GET",
            `${process.env.REACT_APP_BACKEND_BASE_URL}/api/users/parameter12Values`
          );

          if (response && Array.isArray(response)) {
            setHospitals(response);
          }
        } catch (error) {
          console.error("Error fetching hospitals:", error);
          setHospitals([]);
        } finally {
          setLoadingHospitals(false);
        }
      }
    };

    fetchHospitals();
  }, [updatedUser.Role, execute]);


  useEffect(() => {
    isTestEnv && console.log("setUpdatedUser");
    if (rolesList.length > 0) {
      const jsonRoles = user.Role.reduce((acc, roleId) => {
        const role = rolesList.find((role) => role._id === roleId);
        if (role) {
          acc[roleId] = role.Name; // Assign role name to corresponding roleId
        }
        return acc;
      }, {});
      setUpdatedUser({ ...user, Role: jsonRoles });
    }
  }, [user, rolesList]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpdatedUser((prevUser) => ({ ...prevUser, [name]: value }));
  };
  const handleRoleChange = (event) => {

    const { value } = event.target;
    isTestEnv && console.log("handleRoleChange", value);
    if (rolesList.length > 0) {
      const jsonRoles = value.reduce((acc, roleName) => {
        const role = rolesList.find((role) => role.Name === roleName);
        if (role) {
          acc[role._id] = role.Name; // Assign role name to corresponding roleId
        }
        return acc;
      }, {});
      setUpdatedUser((prevUser) => ({ ...prevUser, Role: jsonRoles }));
    }
  };
  const handleBranchesChange = (event) => {
    isTestEnv && console.log("eventTarget", event.target);
    const { value } = event.target;

    if (Array.isArray(value) && value.includes("בחר הכל")) {
      setUpdatedUser((prevUser) => ({ ...prevUser, Branches: [] }));
    } else {
      setUpdatedUser((prevUser) => ({ ...prevUser, Branches: value }));
    }
  };

  const handleHospitalChange = (event) => {
    const { value } = event.target;
    setUpdatedUser((prevUser) => ({ ...prevUser, Hospital: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onUpdateUser(updatedUser);
  };

  return (
    <TableRow>
      <TableCell>
        <TextField
          name="Name"
          value={updatedUser.Name || user.Name}
          onChange={handleInputChange}
          helperText={translations.firstName}
          variant="standard"
          required
        />
        <TextField
          name="LastName"
          value={updatedUser.LastName || user.LastName}
          onChange={handleInputChange}
          margin="none"
          helperText={translations.lastName}
          variant="standard"
          required
        />
      </TableCell>

      <TableCell>
        <TextField
          name="Email"
          value={updatedUser.Email.toLowerCase() || user.Email.toLowerCase()}
          onChange={handleInputChange}
          margin="none"
          helperText=" "
          variant="standard"
          fullWidth
          required
          type="email"
        />
      </TableCell>
      <TableCell>
        <TextField
          name="PriorityUserName"
          value={
            updatedUser.PriorityUserName?.toLowerCase() ||
            user.PriorityUserName?.toLowerCase()
          }
          onChange={handleInputChange}
          margin="none"
          helperText=" "
          variant="standard"
          fullWidth
        />
      </TableCell>
      <TableCell>
        <Select
          name="Role"
          multiple
          value={updatedUser?.Role ? Object.values(updatedUser?.Role) : []}
          onChange={handleRoleChange}
          margin="none"
          variant="standard"
          fullWidth
          required
        >
          {rolesList
            .filter((role) => {
              const hasAdmin = rolesList
                .some(r => r.admin === true && user.Role.includes(r._id));

              if (hasAdmin) {
                return true;
              }

              return user.Role.includes(role._id);
            })
            .map((role) => (
              <MenuItem key={role._id} value={role.Name}>
                {role.Name}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{translations.selectMultipleRoles}</FormHelperText>
      </TableCell>

      <TableCell>
        <Select
          name="Branches"
          multiple
          value={updatedUser.Branches || user.Branches || []}
          onChange={handleBranchesChange}
          margin="none"
          variant="standard"
          fullWidth
          required
          displayEmpty
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return <span style={{ color: '#999' }}>הרשאה לכל הסניפים</span>;
            }
            return selected.join(", ");
          }}
        >
          <MenuItem value="בחר הכל">
            <Checkbox
              checked={(updatedUser.Branches || user.Branches || []).length === 0}
              onChange={(e) => {
                if (e.target.checked) {
                  setUpdatedUser(prev => ({ ...prev, Branches: [] }));
                }
              }}
            />
            <ListItemText primary="בחר הכל" />
          </MenuItem>
          {Array.isArray(allBranches) && allBranches?.map((branch) => (
            <MenuItem key={branch.BRANCHNAME} value={branch.BRANCHNAME}>
              {branch.BRANCHNAME}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>* השארת שדה ריק = הרשאה לכל הסניפים</FormHelperText>
      </TableCell>

      <TableCell>
        <Select
          name="tradeDelayRole"
          value={updatedUser.tradeDelayRole || 'none'}
          onChange={(e) =>
            setUpdatedUser((prev) => ({
              ...prev,
              tradeDelayRole: e.target.value === 'none' ? null : e.target.value,
            }))
          }
          variant="standard"
          size="small"
          sx={{ minWidth: 100 }}
          disabled={!isAdmin}
        >
          <MenuItem value="none">—</MenuItem>
          <MenuItem value="manager">מנהל</MenuItem>
          <MenuItem value="employee">עובד</MenuItem>
        </Select>
      </TableCell>

      {/* עמודת בית חולים - מופיעה רק למשתמשים עם הרשאת ChemoRecordsPage */}
      {hasChemoRecordsPermission() && (
        <TableCell>
          <Select
            name="Hospital"
            value={updatedUser.Hospital || user.Hospital || ""}
            onChange={handleHospitalChange}
            margin="none"
            variant="standard"
            fullWidth
            displayEmpty
            disabled={loadingHospitals}
          >
            <MenuItem value="">
              <em>{loadingHospitals ? "טוען..." : "לא נבחר"}</em>
            </MenuItem>
            {loadingHospitals ? (
              <MenuItem disabled>
                <em>טוען בתי חולים...</em>
              </MenuItem>
            ) : (
              hospitals.map((hospital) => (
                <MenuItem key={hospital.SPECVALUE} value={hospital.SPECVALUE}>
                  {hospital.SPECVALUE}
                </MenuItem>
              ))
            )}
          </Select>
          <FormHelperText>בית חולים</FormHelperText>
        </TableCell>
      )}

      <TableCell align="center">
        <Tooltip title={translations.save}>
          <IconButton
            color="primary"
            aria-label="save user"
            onClick={handleSubmit}
          >
            <CheckIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title={translations.cancelChanges}>
          <IconButton
            color="warning"
            onClick={onCancel}
          >
            <ClearIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default UpdateUserForm;
